import { object } from 'common/helpers'


export const initialState = {}

export const setTour = (state, { name, isStarted }) =>
  object.set(state, name, isStarted)
